import { Navigate, Route, Routes } from 'react-router-dom';

import { AppLayout } from '@/components/Layout';
import { AuthProvider } from '@/features/auth/AuthContext';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { AcceptInvitePage } from '@/routes/AcceptInvitePage';
import { AccountsPage } from '@/routes/AccountsPage';
import { CardsPage } from '@/routes/CardsPage';
import { CategoriesPage } from '@/routes/CategoriesPage';
import { DashboardPage } from '@/routes/DashboardPage';
import { HelpPage } from '@/routes/HelpPage';
import { InstitutionsPage } from '@/routes/InstitutionsPage';
import { InvoicePage } from '@/routes/InvoicePage';
import { LoginPage } from '@/routes/LoginPage';
import { RecurrencesPage } from '@/routes/RecurrencesPage';
import { ResetPasswordPage } from '@/routes/ResetPasswordPage';
import { TransactionsPage } from '@/routes/TransactionsPage';

const protectedRoutes: { path: string; element: JSX.Element }[] = [
  { path: '/', element: <DashboardPage /> },
  { path: '/accounts', element: <AccountsPage /> },
  { path: '/cards', element: <CardsPage /> },
  { path: '/invoices/:invoiceId', element: <InvoicePage /> },
  { path: '/transactions', element: <TransactionsPage /> },
  { path: '/recurrences', element: <RecurrencesPage /> },
  { path: '/categories', element: <CategoriesPage /> },
  { path: '/institutions', element: <InstitutionsPage /> },
  { path: '/help', element: <HelpPage /> },
];

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invites/:token" element={<AcceptInvitePage />} />
        <Route path="/reset/:token" element={<ResetPasswordPage />} />
        {protectedRoutes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={
              <RequireAuth>
                <AppLayout>{element}</AppLayout>
              </RequireAuth>
            }
          />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
